import { defineMessages } from 'react-intl'

const messages = defineMessages({
  assetHireInformation: {
    id: 'assethire.information',
    description: 'Asset Hire Information',
    defaultMessage: 'Asset Hire Information',
  },
  templateNotFound: {
    id: 'assethire.template_not_found',
    description: 'Template not found',
    defaultMessage: 'Tracking Number Template not found',
  },
  loads: {
    id: 'assethire.loads',
    description: 'Consignment Load',
    defaultMessage: 'Loads',
  },
  consignmentLoad: {
    id: 'assethire.consignment_load',
    description: 'Consignment Load',
    defaultMessage: 'Load',
  },
  consignmentLoadContents: {
    id: 'assethire.consignment_load_contents',
    description: 'Load Contents',
    defaultMessage: 'Contents',
  },
  summary: {
    id: 'assethire.summary',
    description: 'Summary',
    defaultMessage: 'Summary',
  },
  shipFromDeliverTo: {
    id: 'assethire.ship_from_deliver_to',
    description: 'Ship From / Deliver To',
    defaultMessage: 'Ship From / Deliver To',
  },
  saveDraft: {
    id: 'assethire.save_draft',
    description: 'Save Draft',
    defaultMessage: 'Save Draft',
  },
  consignment: {
    id: 'assethire.consignment',
    description: 'Consignment',
    defaultMessage: 'Consignment(s)',
  },
  consignmentReferenceNumber: {
    id: 'assethire.consignment_reference_number',
    description: 'Reference Number',
    defaultMessage: 'Reference Number',
  },
  consignmentTrackingNumber: {
    id: 'assethire.consignment_tracking_number',
    description: 'Consignment Tracking Number',
    defaultMessage: 'Tracking Number (auto-generated)',
  },
  systemGenerated: {
    id: 'assethire.system_generated',
    description: 'System Generated',
    defaultMessage: 'System Generated',
  },
  consignmentDescription: {
    id: 'assethire.consignment_description',
    description: 'Consignment Description',
    defaultMessage: 'Description',
  },
  currency: {
    id: 'assethire.currency',
    description: 'Currency',
    defaultMessage: 'Currency',
  },
  addConsignment: {
    id: 'assethire.add_consignment',
    description: 'Add Consignment',
    defaultMessage: 'Add Consignment',
  },
  customer: {
    id: 'assethire.customer',
    description: 'Customer',
    defaultMessage: 'Customer',
  },
  customerReferenceNumber: {
    id: 'assethire.customer_reference_number',
    description: 'Customer Reference Number',
    defaultMessage: 'Customer Reference Number',
  },
  assetHireNumber: {
    id: 'assethire.number',
    description: 'Asset Hire Number',
    defaultMessage: 'Asset Hire Number (auto-generated)',
  },
  deliverTo: {
    id: 'assethire.deliver_to',
    description: 'Deliver To',
    defaultMessage: 'Deliver To',
  },
  workforceQuantity: {
    id: 'assethire.workforce_quantity',
    description: 'Workforce Quantity',
    defaultMessage: 'Workforce Quantity',
  },
  location: {
    id: 'assethire.location',
    description: 'Location',
    defaultMessage: 'Location',
  },
  deliveryDate: {
    id: 'assethire.delivery_date',
    description: 'Delivery Date & Time',
    defaultMessage: 'Delivery Date',
  },
  pickupLocationName: {
    id: 'assethire.pickup_location_name',
    description: 'Pickup Location Name',
    defaultMessage: 'Pickup Location',
  },
  returnLocationName: {
    id: 'assethire.return_location_name',
    description: 'Return Location Name',
    defaultMessage: 'Return Location',
  },
  pickupDate: {
    id: 'assethire.pickup_date',
    description: 'Pickup Date & Time',
    defaultMessage: 'Pickup Date',
  },
  returnDate: {
    id: 'assethire.return_date',
    description: 'Return Date & Time',
    defaultMessage: 'Return Date',
  },
  contact: {
    id: 'assethire.contact',
    description: 'Contact',
    defaultMessage: 'Contact',
  },
  noContactsAvailable: {
    id: 'assethire.no_contacts_available',
    description: 'No Available Contacts',
    defaultMessage: 'No Available Contacts',
  },
  specialInstructions: {
    id: 'assethire.specialInstructions',
    description: 'Special Instructions',
    defaultMessage: 'Special Instructions',
  },
  address: {
    id: 'assethire.selected_location',
    description: 'Address',
    defaultMessage: 'Address',
  },
  clearingRequired: {
    id: 'assethire.clearing_required',
    description: 'Clearing Required',
    defaultMessage: 'Clearing Required',
  },
  showContents: {
    id: 'assethire.show_package_contents',
    description: 'Show Contents',
    defaultMessage: 'Show Contents',
  },
  packageContent: {
    id: 'assethire.package_content',
    description: 'Contents',
    defaultMessage: 'Contents',
  },
  declaredValue: {
    id: 'assethire.declared_value',
    description: 'Declared Value',
    defaultMessage: 'Declared Value',
  },
  specifyContent: {
    id: 'assethire.specify_content',
    description: 'Specify Content',
    defaultMessage: 'Specify Contents',
  },
  contentDescription: {
    id: 'assethire.content_description',
    description: 'Content Description',
    defaultMessage: 'Content Description',
  },
  unitPrice: {
    id: 'assethire.unit_price',
    description: 'Unit Price',
    defaultMessage: 'Unit Price',
  },
  addProduct: {
    id: 'assethire.add_product',
    description: 'Add Product',
    defaultMessage: 'Add Product',
  },
  addItem: {
    id: 'assethire.add_item',
    description: 'Add Item',
    defaultMessage: 'Add Item',
  },
  removeProduct: {
    id: 'assethire.remove_product',
    description: 'Remove Product',
    defaultMessage: 'Remove',
  },
  customerInformation: {
    id: 'assethire.customer_information',
    description: 'Customer Information',
    defaultMessage: 'Customer Information',
  },
  consignmentInformation: {
    id: 'assethire.consignment_information',
    description: 'Consignment Information',
    defaultMessage: 'Consignment Information',
  },
  shipFrom: {
    id: 'assethire.ship_from',
    description: 'Ship From',
    defaultMessage: 'Ship From',
  },
  assetConfigurationQuantity: {
    id: 'assethire.asset_configuration_quantity',
    description: 'Quantity',
    defaultMessage: 'AC Quantity',
  },
  scheduledDate: {
    id: 'assethire.scheduled_date',
    description: 'Scheduled Date',
    defaultMessage: 'Scheduled Date',
  },
  addLoad: {
    id: 'assethire.add_load',
    description: 'Add Load',
    defaultMessage: 'Add Load',
  },
  loadType: {
    id: 'assethire.load_type',
    description: 'Load Type',
    defaultMessage: 'Load Type',
  },
  noOfIdenticalLoads: {
    id: 'assethire.no_of_identical_loads',
    description: 'Number of Identical Loads`',
    defaultMessage: 'No. of Identical {loadType}',
  },
  dimensions: {
    id: 'assethire.dimensions',
    description: 'Dimensions',
    defaultMessage: 'Dimensions',
  },
  weight: {
    id: 'assethire.weight',
    description: 'Weight',
    defaultMessage: 'Weight',
  },
  length: {
    id: 'assethire.length',
    description: 'Length',
    defaultMessage: 'Length',
  },
  width: {
    id: 'assethire.width',
    description: 'Width',
    defaultMessage: 'Width',
  },
  height: {
    id: 'assethire.height',
    description: 'Height',
    defaultMessage: 'Height',
  },
  products: {
    id: 'assethire.products',
    description: 'Products',
    defaultMessage: 'Products',
  },
  productDescription: {
    id: 'assethire.product_description',
    description: 'Product Description',
    defaultMessage: 'Product Description',
  },
  countryOfOrigin: {
    id: 'assethire.country_of_origin',
    description: 'Country of Origin',
    defaultMessage: 'Country of Origin',
  },
  quantity: {
    id: 'assethire.quantity',
    description: 'Quantity',
    defaultMessage: 'Quantity',
  },
  totalValue: {
    id: 'assethire.total_value',
    description: 'Total Value',
    defaultMessage: 'Total Value',
  },
  useProduct: {
    id: 'assethire.use_product',
    description: 'Use Product',
    defaultMessage: 'Use Product',
  },
  isHazardous: {
    id: 'assethire.isHazardous',
    description: 'Is Hazardous',
    defaultMessage:
      'The contents of this load contain elements of lithium or other flammable and hazardous material',
  },
  remove: {
    id: 'assethire.remove',
    description: 'Remove',
    defaultMessage: 'Remove',
  },
  containerType: {
    id: 'assethire.container_type',
    description: 'Container Type',
    defaultMessage: 'Container Type',
  },
  palletType: {
    id: 'assethire.pallet_type',
    description: 'Pallet Type',
    defaultMessage: 'Pallet Type',
  },
  temperatureSetPoint: {
    id: 'assethire.temperature_set_point',
    description: 'Temperature Set Point',
    defaultMessage: 'Set Point',
  },
  isStackable: {
    id: 'common.isStackable',
    defaultMessage: 'Is Stackable',
    description: 'The label for the is stackable',
  },
  product: {
    id: 'assethire.product',
    description: 'Product',
    defaultMessage: 'Product',
  },
  returnTo: {
    id: 'assethire.return_to',
    description: 'Return To',
    defaultMessage: 'Return To',
  },
  sameAsDefault: {
    id: 'assethire.same_as_default',
    description: 'Same as Default',
    defaultMessage: 'Same as Ship From',
  },
  different: {
    id: 'assethire.different',
    description: 'Different',
    defaultMessage: 'Different',
  },
  description: {
    id: 'common.description',
    defaultMessage: 'Description',
    description: 'The label for the description',
  },
  autoGenerated: {
    id: 'common.autoGenerated',
    defaultMessage: 'Auto Generated',
    description: 'The label for the auto generated',
  },
  shipper: {
    id: 'assethire.shipper',
    description: 'Shipper',
    defaultMessage: 'Shipper',
  },
  lowerWarning: {
    id: 'assethire.lower_warning',
    description: 'Lower Warning',
    defaultMessage: 'Lower Warning',
  },
  upperWarning: {
    id: 'assethire.upper_warning',
    description: 'Upper Warning',
    defaultMessage: 'Upper Warning',
  },
  lowerCritical: {
    id: 'assethire.lower_critical',
    description: 'Lower Critical',
    defaultMessage: 'Lower Critical',
  },
  upperCritical: {
    id: 'assethire.upper_critical',
    description: 'Upper Critical',
    defaultMessage: 'Upper Critical',
  },
  modeOfTransit: {
    id: 'assethire.mode_of_transit',
    description: 'Mode of Transit',
    defaultMessage: 'Preferred Mode of Transit',
  },
  noPreference: {
    id: 'assethire.no_preference',
    description: 'No Preference',
    defaultMessage: 'No Preferred Carrier',
  },
  preferredCarrier: {
    id: 'assethire.preferred_carrier',
    description: 'Preferred Carrier',
    defaultMessage: 'Preferred Carrier',
  },
  preBookedTransit: {
    id: 'assethire.pre_booked_transit',
    description: 'Pre-booked Transit',
    defaultMessage: 'Pre-booked Transit',
  },
  carrier: {
    id: 'assethire.carrier',
    description: 'Carrier',
    defaultMessage: 'Carrier',
  },
  transitIdentifier: {
    id: 'assethire.transit_identifier',
    description: 'Transit Identifier',
    defaultMessage: 'Transit Identifier',
  },
  enterCarrier: {
    id: 'assethire.enter_carrier',
    description: 'Enter carrier',
    defaultMessage: 'Enter carrier',
  },
  enterTransitIdentifier: {
    id: 'assethire.enter_transit_identifier',
    description: 'Enter transit identifier',
    defaultMessage: 'Enter transit identifier',
  },
  crossBorder: {
    id: 'assethire.cross_border',
    description: 'Cross Border',
    defaultMessage: 'Cross Border',
  },
  transitDetails: {
    id: 'assethire.transit_details',
    description: 'Transit Details',
    defaultMessage: 'Transit Details',
  },
  showTransitDetails: {
    id: 'assethire.show_transit_details',
    description: 'Show Transit Details',
    defaultMessage: 'Show Transit Details',
  },
  addWaypoint: {
    id: 'assethire.add_waypoint',
    description: 'Add Waypoint',
    defaultMessage: 'Add Waypoint',
  },
  waypoint: {
    id: 'assethire.waypoint',
    description: 'Waypoint',
    defaultMessage: 'Waypoint',
  },
  assetHireUpdated: {
    id: 'assethire.updated',
    description: 'Asset Hire updated',
    defaultMessage: 'Asset Hire updated',
  },
  assetHireCreated: {
    id: 'assethire.created',
    description: 'Asset Hire created',
    defaultMessage: 'Asset Hire created',
  },
  acceptAssetHire: {
    id: 'assethire.accept',
    description: 'Accept Asset Hire',
    defaultMessage: 'Accept',
  },
  submitAssetHire: {
    id: 'assethire.submit',
    description: 'Submit Asset Hire',
    defaultMessage: 'Submit',
  },
  assetHireAcceptFailed: {
    id: 'assethire.accept_failed',
    description: 'Failed to accept Asset Hire',
    defaultMessage: 'Failed to accept Asset Hire',
  },
  assetHireSubmitted: {
    id: 'assethire.submitted',
    description: 'Asset Hire accepted',
    defaultMessage: 'Asset Hire Submitted',
  },
  assetHireAccepted: {
    id: 'assethire.accepted',
    description: 'Asset Hire accepted',
    defaultMessage: 'Asset Hire Accepted',
  },
  submitAndAccept: {
    id: 'assethire.submit_and_accept',
    description: 'Submit and Accept',
    defaultMessage: 'Submit and Accept',
  },
  status: {
    id: 'assethire.status',
    description: 'Status',
    defaultMessage: 'Status',
  },
  lockForReview: {
    id: 'assethire.lock_for_review',
    description: 'Lock for Review',
    defaultMessage: 'Lock for Review',
  },
  acceptedStatus: {
    id: 'assethire.accepted_status',
    description: 'Accepted',
    defaultMessage: 'Accepted',
  },
  submittedStatus: {
    id: 'assethire.submitted_status',
    description: 'Submitted',
    defaultMessage: 'Submitted',
  },
  draftStatus: {
    id: 'assethire.draft_status',
    description: 'Draft',
    defaultMessage: 'Draft',
  },
  newAssetHire: {
    id: 'assethire.new_assetHire',
    description: 'New ASset Hire',
    defaultMessage: 'New Asset Hire',
  },
  AssetHires: {
    id: 'assethire.assetHires',
    description: 'Asset Hires',
    defaultMessage: 'Asset Hires',
  },
  submittedDate: {
    id: 'assethire.submitted_date',
    description: 'Submitted Date',
    defaultMessage: 'Submitted Date',
  },
  numberOfBookings: {
    id: 'assethire.number_of_bookings',
    description: 'Number of Bookings',
    defaultMessage: 'Number of Bookings',
  },
  acceptedDate: {
    id: 'assethire.accepted_date',
    description: 'Accepted Date',
    defaultMessage: 'Accepted Date',
  },
  assetHireUpdateSuccess: {
    id: 'assethire.assetHireUpdateSuccess',
    description: 'Asset Hire update success message',
    defaultMessage: 'Asset Hire updated successfully',
  },
  assetHireUpdateError: {
    id: 'assethire.assetHireUpdateError',
    description: 'Asset Hire update error message',
    defaultMessage: 'Failed to  update Asset Hire',
  },
  countdownTitle: {
    id: 'assethire.countdown_title',
    description: 'Countdown Title',
    defaultMessage: 'Locked for review for {value}',
  },
  backToAssetHiresBtn: {
    id: 'assethire.back_to_assetHIres_btn',
    description: 'Back to Asset Hires',
    defaultMessage: 'Back to Asset Hires',
  },
  buttonReject: {
    id: 'assethire.button_reject',
    description: 'Reject',
    defaultMessage: 'Reject',
  },
  assetHireRejected: {
    id: 'assethire.assetHire_rejected',
    description: 'Asset Hire rejected',
    defaultMessage: 'Asset Hire rejected',
  },
  assetHireRejectFailed: {
    id: 'assethire.assethire_reject_failed',
    description: 'Failed to reject Asset Hire',
    defaultMessage: 'Failed to reject Asset Hire',
  },
  buttonRecall: {
    id: 'assethire.button_recall',
    description: 'Recall',
    defaultMessage: 'Recall',
  },
  assetHireRecalled: {
    id: 'assethire.recalled',
    description: 'Asset Hire recalled',
    defaultMessage: 'Asset Hire recalled',
  },
  assetHireRecallFailed: {
    id: 'assethire.recall_failed',
    description: 'Failed to recall Asset Hire',
    defaultMessage: 'Failed to recall Asset Hire',
  },
  assetHireSubmittedSuccess: {
    id: 'assethire.SubmittedSuccess',
    description: 'Asset Hire submitted success message',
    defaultMessage: 'Asset Hire submitted successfully',
  },
  assetHireSubmitFailed: {
    id: 'assethire.SubmitFailed',
    description: 'Asset Hire submit failed message',
    defaultMessage: 'Failed to submit Asset Hire',
  },
  assetHireTrackingNumber: {
    id: 'assethire.tracking_number',
    description: 'Asset Hire Tracking Number',
    defaultMessage: 'Asset Hire Tracking Number',
  },
  cargoValue: {
    id: 'assethire.cargo_value',
    description: 'Cargo Value',
    defaultMessage: 'Cargo Value',
  },
  assetHireSubmissionFailed: {
    id: 'assethire.submission_failed',
    description: 'Asset Hires submission failed',
    defaultMessage: 'Asset Hires submission failed',
  },
  unitLabel: {
    id: 'assethire.unit_name',
    description: 'Unit Name',
    defaultMessage: 'Units',
  },
  emptyContainerReturn: {
    id: 'assethire.empty_container_return',
    description: 'Empty Container Return',
    defaultMessage: 'Empty Container Return',
  },
  emptyContainerCollection: {
    id: 'assethire.empty_container_collection',
    description: 'Empty Container Collection',
    defaultMessage: 'Empty Container Collection',
  },
  useEmptyContainerCollection: {
    id: 'assethire.use_empty_container_collection',
    description: 'Use Empty Container Collection',
    defaultMessage: 'Collect Empty Container',
  },
  useEmptyContainerReturn: {
    id: 'assethire.use_empty_container_return',
    description: 'Use Empty Container Return',
    defaultMessage: 'Return Empty Container',
  },
  assetHire: {
    id: 'assethire.assetHire',
    description: 'Asset Hire',
    defaultMessage: 'Booking',
  },
  load: {
    id: 'assethire.load',
    description: 'Load',
    defaultMessage: 'Load(s)',
  },
  contents: {
    id: 'assethire.contents',
    description: 'Contents',
    defaultMessage: 'Contents',
  },
  clearSelection: {
    id: 'assethire.clear_selection',
    description: 'Clear Selection',
    defaultMessage: 'Clear Selection',
  },
  selectProduct: {
    id: 'assethire.select_product',
    description: 'Select Product',
    defaultMessage: 'Select Product',
  },
  assetHires: {
    id: 'assetHires.asset_hires',
    description: 'Asset Hires',
    defaultMessage: 'Asset Hires',
  },
  unlock: {
    id: 'assetHires.unlock',
    description: 'Unlock',
    defaultMessage: 'Unlock',
  },
  addAssetHire: {
    id: 'assetHires.add_asset_hire',
    description: 'Add Asset Hire',
    defaultMessage: 'Add Booking',
  },
  assetHireReferenceNumber: {
    id: 'assetHires.asset_hire_reference_number',
    description: 'Asset Hire Reference Number',
    defaultMessage: 'Asset Hire Reference (auto-generated)',
  },
  assetConfiguration: {
    id: 'assetHires.assetConfiguration',
    defaultMessage: 'Asset Configuration',
    description: 'The label for asset configuration',
  },
  startDate: {
    id: 'assetHires.startDate',
    defaultMessage: 'Start Date',
    description: 'The label for start date',
  },
  endDate: {
    id: 'assetHires.endDate',
    defaultMessage: 'End Date',
    description: 'The label for end date',
  },
  assetHireDetails: {
    id: 'assetHires.assetHireDetails',
    description: 'The label for asset hire details',
    defaultMessage: 'Asset Details',
  },
  assetHirePickupDetails: {
    id: 'assetHires.assetHirePickupDetails',
    description: 'The label for asset hire pickup details',
    defaultMessage: 'Pickup Details',
  },
  assetHireReturnDetails: {
    id: 'assetHires.assetHireReturnDetails',
    description: 'The label for asset hire return details',
    defaultMessage: 'Return Details',
  },
  dateAndTime: {
    id: 'assetHires.dateAndTime',
    defaultMessage: 'Date & Time',
    description: 'The label for date and time',
  },
  operation: {
    id: 'assetHires.operation',
    defaultMessage: 'Operation',
    description: 'The label for operation',
  },
  operationDetails: {
    id: 'assetHires.operationDetails',
    defaultMessage: 'Operation Details',
    description: 'The label for operation details',
  },
  workforceType: {
    id: 'assetHires.workforceType',
    defaultMessage: 'Workforce Type',
    description: 'The label for workforce type',
  },
  workforceDetails: {
    id: 'assetHires.workforceDetails',
    defaultMessage: 'Workforce Details',
    description: 'The label for workforce details',
  },
  addWorkforceType: {
    id: 'assetHires.addWorkforce',
    defaultMessage: 'Add Workforce Type',
    description: 'The label for add workforce',
  },
  lastStatusChangeDate: {
    id: 'assetHires.lastStatusChangeDate',
    description: 'The label for last status change date',
    defaultMessage: 'Last Status Change',
  },
  noBooking: {
    id: 'assetHires.noBooking',
    description: 'The label for no booking',
    defaultMessage: 'At least one booking is required',
  },
})
export default messages
